// extracted by mini-css-extract-plugin
export var actionButton = "_x7-2";
export var card = "_x7-0";
export var disambiguationList = "_x7-3";
export var errorCard = "_x7-4";
export var row = "_x7-1";